export default __webpack_public_path__ + "static/media/image-cardThemeBasicExample-2000x3000-png.084f5af0.png";